import Button from './_button.js'
import SelectedIndicator from './_selected-indicator.js'

export default {
  name: 'SelectableButton',
  values: {
    unselected: {
      configSet: Button,
      configValues: {},
    },
    selected: {
      configSet: Button,
      configValues: {},
    },
    indicator: {
      configSet: SelectedIndicator,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
